export default __webpack_public_path__ + "static/media/zoom_out.855707e9.svg";